// Create a react component that has a title "Buyers love POD" and below it a carousel with user testimonials.
import React from 'react';
import Carousel from "js/components-v2/pages/BuyerPage/Carousel";
import userCountry from 'js/services/UserCountry';
import CarouselNG from 'js/components-v2/pages/BuyerPage/CarouselNG';

const LovePod = () => {
  return (
    <div className="buyer-love-pod">
      <div className="pod-container">
        <div className="love-header d-flex justify-content-center">
          <h1 className="love-header">Buyers love POD</h1>
        </div>
        {userCountry() !== 'NG' ? <Carousel/> : <CarouselNG />}
      </div>
    </div>
  );
};

export default LovePod;
